import __var_0__ from '@stdlib/number/float64/base/to-float32';
import __var_1__ from '@stdlib/stats/base/snanvariancetk';
import __var_2__ from '@stdlib/math/base/special/sqrt';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var float64ToFloat32 = __var_0__;
var snanvariancetk = __var_1__;
var sqrt = __var_2__;


// MAIN //

/**
* Computes the standard deviation of a single-precision floating-point strided array ignoring `NaN` values and using a one-pass textbook algorithm.
*
* @param {PositiveInteger} N - number of indexed elements
* @param {number} correction - degrees of freedom adjustment
* @param {Float32Array} x - input array
* @param {integer} stride - stride length
* @returns {number} standard deviation
*
* @example
* var Float32Array = require( '@stdlib/array/float32' );
*
* var x = new Float32Array( [ 1.0, -2.0, NaN, 2.0 ] );
*
* var v = snanstdevtk( x.length, 1, x, 1 );
* // returns ~2.0817
*/
function snanstdevtk( N, correction, x, stride ) {
	return float64ToFloat32( sqrt( snanvariancetk( N, correction, x, stride ) ) ); // eslint-disable-line max-len
}


// EXPORTS //
export default snanstdevtk;
